import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NavComponent } from './components/nav/nav.component';
import { LayoutModule } from '@angular/cdk/layout';

import { DashComponent } from './components/dashboard/dash.component';

import { NgScrollbarModule } from 'ng-scroller';

import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';

import { InterceptorService } from './services/misc/loader/interceptor.service';
import { MaterialModules } from './modules/material-modules';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import {
//   GroupsComponent
// } from './components/groups/groups.component';
// import {
//   ThingsComponent
// } from './components/things/things.component';
// import {
//   UsersComponent
// } from './components/users/users.component';
import { GatekeeperComponent } from './components/gatekeeper/gatekeeper.component';
import { AddUsersDialogComponent } from './dialogs/add-users-dialog/add-users-dialog.component';
import { AddThingsDialogComponent } from './dialogs/add-things-dialog/add-things-dialog.component';
// import {
//   ViewProfileDialogComponent
// } from './dialogs/change-password-dialog/change-password-dialog.component';

import { ChangePasswordDialogComponent } from './dialogs/change-password-dialog/change-password-dialog.component';
import { ViewProfileDialogComponent } from './dialogs/view-profile-dialog/view-profile-dialog.component';

import { DevicelistComponent } from './components/devicelist/devicelist.component';
// import {
//   DevicedetailsComponent
// } from './components/devicedetails/devicedetails.component';
import { AccountComponent } from './components/account/account.component';
import { NgCircleProgressModule } from 'ng-circle-progress';

import { ProgressBarModule } from 'angular-progress-bar';
import { GoogleChartsModule } from 'angular-google-charts';
import { ResetpassComponent } from './components/resetpass/resetpass.component';
import { RebootDialogComponent } from './dialogs/reboot-dialog/reboot-dialog.component';

@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    DashComponent,
    GatekeeperComponent,
    AddUsersDialogComponent,
    AddThingsDialogComponent,
    ViewProfileDialogComponent,
    ChangePasswordDialogComponent,
    DevicelistComponent,
    AccountComponent,
    ResetpassComponent,
    RebootDialogComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MaterialModules,
    LayoutModule,
    FormsModule,
    FormsModule,
    ReactiveFormsModule,
    NgCircleProgressModule.forRoot(),
    ProgressBarModule,
    GoogleChartsModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
